export default __webpack_public_path__ + "static/media/calendar_active.7724ade0.svg";